// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyDgobx9mOP__vzaAvLaEXt_neKJVloL2CI",
    authDomain: "studybio-241907.firebaseapp.com",
    databaseURL: "https://studybio-241907.firebaseio.com",
    projectId: "studybio-241907",
    storageBucket: "studybio-241907.appspot.com",
    messagingSenderId: "397904555791",
    appId: "1:397904555791:web:52380318aeaa1041a3987a",
    measurementId: "G-VVP9XNFZRE"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
